// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { 
//   Container, Chip, Divider, CardActions, Grid, Card, CardMedia, 
//   CardContent, Typography, Button, Box, IconButton, Dialog, 
//   DialogTitle, DialogContent, DialogActions, TextField, MenuItem,
//   Select, FormControl, InputLabel, Fab, Tooltip
// } from "@mui/material";
// import { 
//   AccessTime, ArrowBack, Edit, Delete, Add as AddIcon, 
//   Image as ImageIcon, Save, Close 
// } from "@mui/icons-material";
// import "../styles/home.css";  
// import axios from "axios";

// // PrimeReact imports
// import { Editor } from 'primereact/editor';
// import 'primereact/resources/themes/lara-light-indigo/theme.css';
// import 'primereact/resources/primereact.min.css';
// import 'primeicons/primeicons.css';

// const Blogs = ({ role }) => {
  
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [blogs, setBlogs] = useState([]);
//   const [selectedBlog, setSelectedBlog] = useState(null);
//   const [featuredBlog, setFeaturedBlog] = useState(null);
//   const [editMode, setEditMode] = useState(false);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [openImageDialog, setOpenImageDialog] = useState(false);
//   const [currentImageIndex, setCurrentImageIndex] = useState(null);
  
//   // Form states for editing or creating
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     category: "",
//     content: "",
//     image: "",
//     featured: false,
//     insertImageAfter: 2,
//     additionalImages: []
//   });
  
//   // New image data
//   const [imageData, setImageData] = useState({
//     file: null,
//     position: 0,
//     caption: ""
//   });

//   // Compute insertPosition and paragraphs only when selectedBlog exists
//   const insertPosition = selectedBlog?.insertImageAfter ?? 2;
//   const paragraphs = selectedBlog?.content ? selectedBlog.content.split('\n\n') : [];

//   useEffect(() => {
//     // Fetch blogs from API
//     fetchBlogs();
//   }, [id]);

//   const fetchBlogs = async () => {
//     try {
//       const response = await axios.get('/api/blogs');
//       const blogsData = response.data;
      
//       setBlogs(blogsData.posts);
      
//       // Set featured blog (first blog or one marked as featured)
//       const featured = blogsData.posts.find(blog => blog.featured) || blogsData.posts[0];
//       setFeaturedBlog(featured);
      
//       // Set selected blog if ID is in URL
//       if (id) {
//         const blogDetailResponse = await axios.get(`/api/blogs/${parseInt(id)}`);
//         setSelectedBlog(blogDetailResponse.data);
//         // Scroll to top when blog detail page loads
//         window.scrollTo(0, 0);
//       } else {
//         setSelectedBlog(null);
//       }
//     } catch (error) {
//       console.error("Error fetching blogs:", error);
//     }
//   };

//   // Function to format date in a more readable way
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     if (dateString === "Today" || dateString === "Yesterday" || dateString.includes("days ago")) {
//       return dateString;
//     }
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({
//       ...formData,
//       [name]: type === 'checkbox' ? checked : value
//     });
//   };

//   // Handle content change from PrimeReact Editor
//   const handleEditorChange = (htmlContent) => {
//     setFormData({
//       ...formData,
//       content: htmlContent
//     });
//   };

// // Handle image upload
// // Handle image upload
// const handleImageUpload = async (e) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   const cloudinaryData = new FormData(); // Renamed to avoid conflict
//   cloudinaryData.append('file', file);
//   cloudinaryData.append("upload_preset", "Brian_Karsh");

//   try {
//     // Upload directly to Cloudinary
//     const response = await fetch("https://api.cloudinary.com/v1_1/dyglrkcfq/image/upload", {
//       method: "POST",
//       body: cloudinaryData,
//     });
    
//     const data = await response.json();
    
//     if (data.secure_url) {
//       setImageData(prevImageData => ({
//         ...prevImageData,
//         file: data.secure_url
//       }));
//     }
//   } catch (error) {
//     console.error("Error uploading image to Cloudinary:", error);
//   }
// };

// // Handle main blog image upload
// const handleMainImageUpload = async (e) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   const cloudinaryData = new FormData(); // Renamed to avoid conflict
//   cloudinaryData.append('file', file);
//   cloudinaryData.append("upload_preset", "Brian_Karsh");

//   try {
//     // Upload directly to Cloudinary
//     const response = await fetch("https://api.cloudinary.com/v1_1/dyglrkcfq/image/upload", {
//       method: "POST",
//       body: cloudinaryData,
//     });
    
//     const data = await response.json();
    
//     if (data.secure_url) {
//       setFormData(prevFormData => ({
//         ...prevFormData,  // Use functional update to reference the previous state
//         image: data.secure_url
//       }));
//     }
//   } catch (error) {
//     console.error("Error uploading image to Cloudinary:", error);
//   }
// };

//   // Add image to the blog content
//   const handleAddImage = () => {
//     if (!imageData.file) return;

//     const newAdditionalImages = [
//       ...formData.additionalImages,
//       {
//         path: imageData.file,
//         position: parseInt(imageData.position),
//         caption: imageData.caption
//       }
//     ];

//     setFormData({
//       ...formData,
//       additionalImages: newAdditionalImages
//     });

//     // Reset image form
//     setImageData({
//       file: null,
//       position: 0,
//       caption: ""
//     });

//     setOpenImageDialog(false);
//   };

//   // Remove additional image
//   const handleRemoveImage = (index) => {
//     const newAdditionalImages = [...formData.additionalImages];
//     newAdditionalImages.splice(index, 1);
    
//     setFormData({
//       ...formData,
//       additionalImages: newAdditionalImages
//     });
//   };

//   // Open edit mode with current blog data
//   const handleEditBlog = () => {
//     if (!selectedBlog) return;

//     setFormData({
//       title: selectedBlog.title || "",
//       description: selectedBlog.description || "",
//       category: selectedBlog.category || "",
//       content: selectedBlog.content || "",
//       image: selectedBlog.image || "",
//       featured: selectedBlog.featured || false,
//       insertImageAfter: selectedBlog.insertImageAfter || 2,
//       additionalImages: selectedBlog.additionalImages || []
//     });

//     setEditMode(true);
//   };

//   // Open create blog dialog
//   const handleOpenCreateDialog = () => {
//     setFormData({
//       title: "",
//       description: "",
//       category: "",
//       content: "",
//       image: "",
//       featured: false,
//       insertImageAfter: 2,
//       additionalImages: []
//     });
//     setOpenDialog(true);
//   };

//   // Create new blog
// // Update your handleCreateBlog function
// const handleCreateBlog = async () => {
//   try {
//     // Get the token from local storage or wherever you store it after login
//     const token = localStorage.getItem('token'); // or from your auth state
    
//     const response = await axios.post('/api/blogs/create', formData, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       }
//     });
    
//     if (response.data.success) {
//       setOpenDialog(false);
//       fetchBlogs();
//       navigate(`/blogs/${response.data.id}`);
//     }
//   } catch (error) {
//     console.error("Error creating blog:", error);
//   }
// };

//   // Update existing blog
//   const handleUpdateBlog = async () => {
//     if (!selectedBlog) return;

//     try {
//       const token = localStorage.getItem('token'); // or from your auth state


//       const response = await axios.put(`/api/blogs/${selectedBlog.id}/update`, formData, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       }
//     });
//       if (response.data.success) {
//         setEditMode(false);
//         fetchBlogs();
//       }
//     } catch (error) {
//       console.error("Error updating blog:", error);
//     }
//   };

//   // Delete blog
//   const handleDeleteBlog = async () => {
//     if (!selectedBlog) return;
  
//     if (window.confirm("Are you sure you want to delete this blog?")) {
//       try {
//         const token = localStorage.getItem('token'); // Get token from localStorage or your auth state
  
//         const response = await axios.delete(`/api/blogs/${selectedBlog.id}/delete`, {
//           headers: {
//             'Authorization': `Bearer ${token}`, // Add Authorization header
//           },
//         });
  
//         if (response.data.success) {
//           navigate('/blogs');
//           fetchBlogs();
//         }
//       } catch (error) {
//         console.error("Error deleting blog:", error);
//       }
//     }
//   };
  

//   // Cancel editing
//   const handleCancelEdit = () => {
//     setEditMode(false);
//   };

//   // Set up Editor header template
//   const editorHeader = (
//     <span className="ql-formats">
//       <button className="ql-bold" aria-label="Bold"></button>
//       <button className="ql-italic" aria-label="Italic"></button>
//       <button className="ql-underline" aria-label="Underline"></button>
//       <button className="ql-strike" aria-label="Strike"></button>
//       <button className="ql-blockquote" aria-label="Blockquote"></button>
//       <button className="ql-list" value="ordered" aria-label="Ordered List"></button>
//       <button className="ql-list" value="bullet" aria-label="Unordered List"></button>
//       <button className="ql-link" aria-label="Insert Link"></button>
//       <button className="ql-image" aria-label="Insert Image"></button>
//       <button className="ql-code-block" aria-label="Code Block"></button>
//       <select className="ql-size">
//         <option value="small">Small</option>
//         <option selected>Normal</option>
//         <option value="large">Large</option>
//         <option value="huge">Huge</option>
//       </select>
//       <select className="ql-header">
//         <option value="1">Heading 1</option>
//         <option value="2">Heading 2</option>
//         <option value="3">Heading 3</option>
//         <option value="4">Heading 4</option>
//         <option value="5">Heading 5</option>
//         <option value="6">Heading 6</option>
//         <option selected>Normal</option>
//       </select>
//     </span>
//   );

//   return (
//     <Container maxWidth="lg" sx={{ mt: 12, mb: 8 }}>
//       {!selectedBlog ? (
//         // Blog listing page
//         <>
//           {/* Hero Section with Featured Blog */}
//           <Box 
//             className="featured-blog" 
//             sx={{ 
//               position: 'relative', 
//               mb: 6, 
//               borderRadius: 2, 
//               overflow: 'hidden',
//               boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//               height: {xs: '400px', md: '500px'}
//             }}
//           >
//             {featuredBlog && (
//               <>
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     width: '100%',
//                     height: '100%',
//                     backgroundImage: `url(${featuredBlog.image})`,
//                     backgroundSize: 'cover',
//                     backgroundPosition: 'center',
//                     '&::after': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       width: '100%',
//                       height: '100%',
//                       background: 'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.2))'
//                     }
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     bottom: 0,
//                     left: 0,
//                     width: '100%',
//                     padding: {xs: 3, md: 5},
//                     color: 'white',
//                     zIndex: 1
//                   }}
//                 >
//                   <Chip 
//                     label="Featured" 
//                     color="primary" 
//                     size="small" 
//                     sx={{ mb: 2 }} 
//                   />
//                   <Typography 
//                     variant="h3" 
//                     component="h1" 
//                     sx={{ 
//                       fontWeight: 700, 
//                       mb: 2,
//                       fontSize: {xs: '1.8rem', sm: '2.5rem', md: '3rem'} 
//                     }}
//                   >
//                     {featuredBlog.title}
//                   </Typography>
//                   <Typography 
//                     variant="body1" 
//                     sx={{ 
//                       mb: 2, 
//                       opacity: 0.9,
//                       display: {xs: 'none', sm: 'block'}
//                     }}
//                   >
//                     {featuredBlog.description}
//                   </Typography>
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                     <AccessTime sx={{ fontSize: 16, mr: 1, opacity: 0.8 }} />
//                     <Typography variant="body2" sx={{ opacity: 0.8 }}>
//                       {formatDate(featuredBlog.date)}
//                     </Typography>
//                   </Box>
//                   <Button 
//                     variant="contained" 
//                     onClick={() => navigate(`/blogs/${featuredBlog.id}`)}
//                     sx={{ mt: 2 }}
//                   >
//                     Read Article
//                   </Button>
//                 </Box>
//               </>
//             )}
//           </Box>

//           {/* Section Title with decoration */}
//           <Box sx={{ display: 'flex', alignItems: 'center', mb: 5, mt: 8 }}>
//             <Divider sx={{ flexGrow: 1, mr: 2 }} />
//             <Typography 
//               variant="h4" 
//               component="h2" 
//               sx={{ 
//                 fontWeight: 700,
//                 position: 'relative',
//                 '&::after': {
//                   content: '""',
//                   position: 'absolute',
//                   bottom: '-8px',
//                   left: '50%',
//                   transform: 'translateX(-50%)',
//                   width: '40px',
//                   height: '4px',
//                   backgroundColor: 'primary.main',
//                   borderRadius: '2px'
//                 }
//               }}
//             >
//               Stay Informed: Latest Articles & Updates
//             </Typography>
//             <Divider sx={{ flexGrow: 1, ml: 2 }} />
//           </Box>

//           {/* Create Blog Button */}
//           <Box sx={{ display: 'flex', mb: 3, ml: 10 }}>
//           {role === "owner" && (
//             <Tooltip title="Create New Blog">
//               <Fab 
//                 color="primary" 
//                 aria-label="add"
//                 onClick={handleOpenCreateDialog}
//                 sx={{
//                   bottom: 32,
//                   right: 82,
//                   zIndex: 1
//                 }}
//               >

     
//             <AddIcon />
          

          


//               </Fab>
//             </Tooltip>
//               )}
//           </Box>

//           {/* Blog Cards */}
//           <Grid container spacing={4} justifyContent="center">
//             {blogs.map((blog) => (
//               <Grid item key={blog.id} xs={12} sm={6} md={4}>
//                 <Card 
//                   className="blog-card" 
//                   sx={{ 
//                     height: '100%', 
//                     display: 'flex', 
//                     flexDirection: 'column', 
//                     cursor: 'pointer',
//                     transition: 'all 0.3s ease',
//                     borderRadius: 2,
//                     overflow: 'hidden',
//                     boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
//                     '&:hover': {
//                       transform: 'translateY(-5px)',
//                       boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
//                     }
//                   }}
//                 >
//                   <Box sx={{ position: 'relative' }}>
//                     <CardMedia 
//                       component="img" 
//                       height="200"
//                       image={blog.image} 
//                       alt={blog.title} 
//                       className="blog-image"
//                       sx={{ 
//                         height: '200px', 
//                         objectFit: 'cover'
//                       }}  
//                     />
//                     {blog.category && (
//                       <Chip
//                         label={blog.category}
//                         size="small"
//                         sx={{
//                           position: 'absolute',
//                           top: 12,
//                           left: 12,
//                           backgroundColor: 'primary.main',
//                           color: 'white',
//                           fontWeight: 600
//                         }}
//                       />
//                     )}
//                   </Box>
//                   <CardContent 
//                     sx={{ 
//                       flexGrow: 1, 
//                       p: 3
//                     }}
//                   >
//                     <Box 
//                       sx={{ 
//                         display: 'flex', 
//                         alignItems: 'center', 
//                         mb: 1,
//                         color: 'text.secondary' 
//                       }}
//                     >
//                       <AccessTime sx={{ fontSize: 16, mr: 1 }} />
//                       <Typography variant="caption">
//                         {formatDate(blog.date)}
//                       </Typography>
//                     </Box>
//                     <Typography 
//                       variant="h6" 
//                       component="h3" 
//                       sx={{ 
//                         fontWeight: 600, 
//                         lineHeight: 1.3,
//                         mb: 1.5,
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis',
//                         display: '-webkit-box',
//                         WebkitLineClamp: 2,
//                         WebkitBoxOrient: 'vertical',
//                       }}
//                     >
//                       {blog.title}
//                     </Typography>
//                     <Typography 
//                       variant="body2" 
//                       color="text.secondary"
//                       sx={{
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis',
//                         display: '-webkit-box',
//                         WebkitLineClamp: 3,
//                         WebkitBoxOrient: 'vertical',
//                         mb: 2
//                       }}
//                     >
//                       {blog.description}
//                     </Typography>
//                   </CardContent>
//                   <CardActions sx={{ p: 2, pt: 0 }}>
//                     <Button 
//                       size="small" 
//                       color="primary"
//                       onClick={() => navigate(`/blogs/${blog.id}`)}
//                       sx={{ ml: 'auto' }}
//                     >
//                       Read More
//                     </Button>
//                   </CardActions>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </>
//       ) : (
//         // Selected Blog Detail View
//         <Box 
//           sx={{
//             textAlign: 'justify',
//             maxWidth: '750px',
//             mx: 'auto',
//             backgroundColor: '#ffffff',
//             pt: { xs: 2, md: 4 }
//           }}
//         >
//           {/* Back Button and Edit/Delete Controls */}
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
//             <Button 
//               startIcon={<ArrowBack />}
//               onClick={() => navigate("/blogs")} 
//               sx={{ 
//                 color: 'text.secondary',
//                 fontWeight: 400,
//                 fontSize: '0.875rem',
//                 pl: 0,
//                 '&:hover': {
//                   backgroundColor: 'transparent',
//                   color: 'primary.main'
//                 }
//               }}
//               variant="text"
//             >
//               Back to Articles
//             </Button>
            
//             {!editMode && (
//               <Box>
//                 <Tooltip title="Edit Blog">
//                   <IconButton 
//                     color="primary" 
//                     onClick={handleEditBlog}
//                     sx={{ mr: 1 }}
//                   >

  
//                        {role === "owner" && (
//                            <Edit />
//                             )}
                  

//                   </IconButton>
//                 </Tooltip>
//                 <Tooltip title="Delete Blog">
//                   <IconButton 
//                     color="error" 
//                     onClick={handleDeleteBlog}
//                   >
                  
//                     {role === "owner" && (
//                           <Delete />
//                             )}
//                   </IconButton>
//                 </Tooltip>
//               </Box>
//             )}
            
//             {editMode && (
//               <Box>
//                 <Tooltip title="Save Changes">
//                   <IconButton 
//                     color="primary" 
//                     onClick={handleUpdateBlog}
//                     sx={{ mr: 1 }}
//                   >
//                     <Save />
//                   </IconButton>
//                 </Tooltip>
//                 <Tooltip title="Cancel">
//                   <IconButton 
//                     color="error" 
//                     onClick={handleCancelEdit}
//                   >
//                     <Close />
//                   </IconButton>
//                 </Tooltip>
//               </Box>
//             )}
//           </Box>
          
//           {!editMode ? (
//             // Normal Blog View
//             <>
//               {/* Blog Header */}
//               <Box sx={{ mb: 6 }}>
//                 {/* Category Tag */}
//                 {selectedBlog.category && (
//                   <Chip 
//                     label={selectedBlog.category} 
//                     size="small" 
//                     color="primary"
//                     sx={{ 
//                       mb: 2.5, 
//                       fontWeight: 500,
//                       borderRadius: '4px',
//                       height: '24px'
//                     }}
//                   />
//                 )}
                
//                 {/* Blog Title */}
//                 <Typography 
//                   variant="h1" 
//                   component="h1" 
//                   sx={{ 
//                     fontWeight: 700, 
//                     lineHeight: 1.2,
//                     mb: 3,
//                     fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
//                     fontFamily: '"Playfair Display", serif',
//                   }}
//                 >
//                   {selectedBlog.title}
//                 </Typography>
                
//                 {/* Meta Info */}
//                 <Box 
//                   sx={{ 
//                     display: 'flex', 
//                     alignItems: 'center', 
//                     mb: 3,
//                     color: 'text.secondary'
//                   }}
//                 >
//                   <Typography 
//                     variant="body2"
//                     sx={{
//                       fontFamily: '"Inter", sans-serif',
//                       fontSize: '0.875rem'
//                     }}
//                   >
//                     {formatDate(selectedBlog.date)}
//                   </Typography>
//                   <Box 
//                     component="span" 
//                     sx={{ 
//                       mx: 1.5, 
//                       width: '4px', 
//                       height: '4px', 
//                       borderRadius: '50%', 
//                       backgroundColor: 'text.secondary', 
//                       display: 'inline-block' 
//                     }} 
//                   />
//                   <Typography 
//                     variant="body2"
//                     sx={{
//                       fontFamily: '"Inter", sans-serif',
//                       fontSize: '0.875rem'
//                     }}
//                   >
//                     {selectedBlog.readTime || '5 min read'}
//                   </Typography>
//                 </Box>
//               </Box>

//               {/* Featured Image */}
//               <Box 
//                 sx={{ 
//                   width: '100%', 
//                   overflow: 'hidden',
//                   mb: 6,
//                 }}
//               >
//                 <img 
//                   src={selectedBlog.image} 
//                   alt={selectedBlog.title} 
//                   style={{
//                     width: '100%',
//                     height: 'auto',
//                     objectFit: 'cover',
//                     maxHeight: '500px',
//                     display: 'block'
//                   }} 
//                 />
//               </Box>
              
//               {/* Content */}
//               <Box 
//                 sx={{
//                   mb: 8,
//                   px: { xs: 2, sm: 0 },
//                   '& p:first-of-type::first-letter': {
//                     fontSize: '3.75rem',
//                     lineHeight: 0.8,
//                     fontWeight: 700,
//                     float: 'left',
//                     mr: 1.5,
//                     mt: 0.5,
//                     fontFamily: '"Playfair Display", serif',
//                   },
//                   '& .blog-content': {
//                     mb: 4,
//                     lineHeight: 1.9,
//                     fontSize: '1.25rem',
//                     color: '#2F2E2E',
//                     fontFamily: '"Inter", sans-serif',
//                     letterSpacing: '0.015em'
//                   }
//                 }}
//               >
//                 {/* If the content is HTML (from rich text editor) */}
//                 {selectedBlog.content.includes('<') && selectedBlog.content.includes('>') ? (
//                   <div 
//                     className="blog-content"
//                     dangerouslySetInnerHTML={{ __html: selectedBlog.content }}
//                   />
//                 ) : (
//                   // If the content is plain text (legacy)
//                   paragraphs.map((para, index) => (
//                     <React.Fragment key={index}>
//                       <Typography
//                         variant="body1"
//                         component="p"
//                         sx={{
//                           mb: 4,
//                           lineHeight: 1.9,
//                           fontSize: '1.25rem',
//                           color: '#2F2E2E',
//                           fontFamily: '"Inter", sans-serif',
//                           letterSpacing: '0.015em',
//                           fontWeight: index === 0 ? 500 : 400
//                         }}
//                       >
//                         {para}
//                       </Typography>
                      
//                       {/* Display additional images at their specified positions */}
//                       {selectedBlog.additionalImages?.some(img => img.position === index + 1) && 
//                         selectedBlog.additionalImages
//                           .filter(img => img.position === index + 1)
//                           .map((img, imgIndex) => (
//                             <Box key={imgIndex} sx={{ my: 5 }}>
//                               <img
//                                 src={img.path} 
//                                 alt={img.caption || `Image ${imgIndex}`}
//                                 style={{
//                                   width: '100%',
//                                   height: 'auto',
//                                   objectFit: 'cover'
//                                 }}
//                               />
//                               {img.caption && (
//                                 <Typography 
//                                   variant="caption" 
//                                   sx={{ 
//                                     display: 'block', 
//                                     textAlign: 'center', 
//                                     mt: 1, 
//                                     color: 'text.secondary',
//                                     fontStyle: 'italic',
//                                     fontFamily: '"Inter", sans-serif',
//                                   }}
//                                 >
//                                   {img.caption}
//                                 </Typography>
//                               )}
//                             </Box>
//                           ))
//                       }
//                     </React.Fragment>
//                   ))
//                 )}
                
//                 {/* Display additional images after content */}
//                 {selectedBlog.additionalImages?.filter(img => !paragraphs[img.position - 1]).map((img, imgIndex) => (
//                   <Box key={imgIndex} sx={{ my: 5 }}>
//                     <img
//                       src={img.path} 
//                       alt={img.caption || `Image ${imgIndex}`}
//                       style={{
//                         width: '100%',
//                         height: 'auto',
//                         objectFit: 'cover'
//                       }}
//                     />
//                     {img.caption && (
//                       <Typography 
//                         variant="caption" 
//                         sx={{ 
//                           display: 'block', 
//                           textAlign: 'center', 
//                           mt: 1, 
//                           color: 'text.secondary',
//                           fontStyle: 'italic',
//                           fontFamily: '"Inter", sans-serif',
//                         }}
//                       >
//                         {img.caption}
//                       </Typography>
//                     )}
//                   </Box>
//                 ))}
//               </Box>

//               {/* Related Articles - Wix style */}
//               <Box sx={{ mt: 10, mb: 4 }}>
//                 <Typography 
//                   variant="h2" 
//                   component="h2" 
//                   sx={{ 
//                     fontWeight: 700, 
//                     mb: 5,
//                     fontSize: '1.75rem',
//                     fontFamily: '"Playfair Display", serif',
//                     position: 'relative',
//                     display: 'inline-block',
//                     '&::after': {
//                       content: '""',
//                       position: 'absolute',
//                       bottom: '-10px',
//                       left: 0,
//                       width: '40px',
//                       height: '3px',
//                       backgroundColor: 'primary.main'
//                     }
//                   }}
//                 >
//                   You might also like
//                 </Typography>
//                 <Grid container spacing={4} sx={{ mt: 2 }}>
//                   {blogs
//                     .filter(blog => blog.id !== selectedBlog.id)
//                     .slice(0, 3)
//                     .map((blog) => (
//                       <Grid item key={blog.id} xs={12} sm={6} md={4}>
//                         <Card 
//                           onClick={() => navigate(`/blogs/${blog.id}`)}
//                           sx={{ 
//                             cursor: 'pointer',
//                             transition: 'all 0.3s ease',
//                             border: 'none',
//                             boxShadow: 'none',
//                             borderRadius: 0,
//                             height: '100%',
//                             display: 'flex',
//                             flexDirection: 'column',
//                             backgroundColor: 'transparent',
//                             '&:hover': {
//                               '& .blog-image': {
//                                 transform: 'scale(1.05)'
//                               },
//                               '& .blog-title': {
//                                 color: 'primary.main'
//                               }
//                             }
//                           }}
//                         >
//                           <Box sx={{ overflow: 'hidden', mb: 2 }}>
//                             <CardMedia 
//                               component="img" 
//                               image={blog.image} 
//                               alt={blog.title}
//                               className="blog-image"
//                               sx={{ 
//                                 transition: 'transform 0.6s ease',
//                                 objectFit: 'cover',
//                                 height: '200px',
//                                 width: '100%',
//                               }}
//                             />
//                           </Box>
//                           <CardContent sx={{ p: 0, flexGrow: 1 }}>
//                             <Typography 
//                               variant="body2" 
//                               color="text.secondary"
//                               sx={{ 
//                                 mb: 1,
//                                 fontFamily: '"Inter", sans-serif',
//                                 fontSize: '0.875rem',
//                                 textTransform: 'uppercase',
//                               }}
//                             >
//                               {formatDate(blog.date)}
//                             </Typography>
//                             <Typography 
//                               variant="subtitle1"
//                               component="h4"
//                               className="blog-title"
//                               sx={{ 
//                                 fontWeight: 600,
//                                 fontFamily: '"Inter", sans-serif',
//                                 fontSize: '1.125rem',
//                                 transition: 'color 0.2s ease',
//                                 overflow: 'hidden',
//                                 textOverflow: 'ellipsis',
//                                 display: '-webkit-box',
//                                 WebkitLineClamp: 2,
//                                 WebkitBoxOrient: 'vertical',
//                                 letterSpacing: 'normal',
//                                 lineHeight: '1.2',
//                                 whiteSpace: 'normal',
//                               }}
//                             >
//                               {blog.title}
//                             </Typography>
//                           </CardContent>
//                         </Card>
//                       </Grid>
//                     ))}
//                 </Grid>
//               </Box>
//             </>
//           ) : (
//             // Edit Mode View with PrimeReact Editor
//             <Box sx={{ mb: 8 }}>
//               {/* Edit Form */}
//               <Grid container spacing={3}>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Blog Title"
//                     name="title"
//                     value={formData.title}
//                     onChange={handleInputChange}
//                     variant="outlined"
//                     required
//                     margin="normal"
//                   />
//                 </Grid>
                
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Category"
//                     name="category"
//                     value={formData.category}
//                     onChange={handleInputChange}
//                     variant="outlined"
//                     margin="normal"
//                   />
//                 </Grid>
                
//                 <Grid item xs={12} sm={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
//                     <input
//                       accept="image/*"
//                       style={{ display: 'none' }}
//                       id="featured-image-upload"
//                       type="file"
//                       onChange={handleMainImageUpload}
//                     />
//                     <label htmlFor="featured-image-upload">
//                       <Button
//                         variant="outlined"
//                         component="span"
//                         startIcon={<ImageIcon />}
//                       >
//                         Upload Cover Image
//                       </Button>
//                     </label>
//                     {formData.image && (
//                       <Typography variant="body2" sx={{ ml: 2 }}>
//                         Image uploaded
//                       </Typography>
//                     )}
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Description"
//                     name="description"
//                     value={formData.description}
//                     onChange={handleInputChange}
//                     variant="outlined"
//                     multiline
//                     rows={3}
//                     margin="normal"
//                     required
//                   />
//                 </Grid>
                
//                 {/* PrimeReact Editor */}
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle1" sx={{ mb: 1 }}>Content</Typography>
//                   <Editor
//                     style={{ height: '400px' }}
//                     value={formData.content}
//                     onTextChange={(e) => handleEditorChange(e.htmlValue)}
//                     headerTemplate={editorHeader}
//                   />
//                 </Grid>
                
//                 <Grid item xs={12}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
//                     <Typography variant="h6" component="h3">
//                       Additional Images
//                     </Typography>
//                     <Button 
//                       variant="contained" 
//                       color="primary"
//                       startIcon={<AddIcon />}
//                       onClick={() => setOpenImageDialog(true)}
//                     >
//                       Add Image
//                     </Button>
//                   </Box>
                  
//                   {/* List of additional images */}
//                   {formData.additionalImages.length > 0 && (
//                     <Box sx={{ mt: 2 }}>
//                       <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                         Inserted Images:
//                       </Typography>
//                       <Grid container spacing={2}>
//                         {formData.additionalImages.map((img, index) => (
//                           <Grid item xs={12} sm={6} md={4} key={index}>
//                             <Card sx={{ position: 'relative' }}>
//                               <CardMedia
//                                 component="img"
//                                 height="140"
//                                 image={img.path}
//                                 alt={img.caption || `Image ${index + 1}`}
//                               />
//                               <CardContent>
//                                 <Typography variant="body2">
//                                   Position: After paragraph {img.position}
//                                 </Typography>
//                                 {img.caption && (
//                                   <Typography variant="body2" color="text.secondary">
//                                     Caption: {img.caption}
//                                   </Typography>
//                                 )}
//                               </CardContent>
//                               <CardActions>
//                                 <IconButton 
//                                   size="small" 
//                                   color="error"
//                                   onClick={() => handleRemoveImage(index)}
//                                 >
//                                   <Delete />
//                                 </IconButton>
//                               </CardActions>
//                             </Card>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </Box>
//                   )}
//                 </Grid>
//               </Grid>
//             </Box>
//           )}
//         </Box>
//       )}
      
//       {/* Create Blog Dialog */}
//       <Dialog 
//         open={openDialog} 
//         onClose={() => setOpenDialog(false)}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle>Create New Blog</DialogTitle>
//         <DialogContent>
//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Blog Title"
//                 name="title"
//                 value={formData.title}
//                 onChange={handleInputChange}
//                 variant="outlined"
//                 required
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Category"
//                 name="category"
//                 value={formData.category}
//                 onChange={handleInputChange}
//                 variant="outlined"
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <input
//                   accept="image/*"
//                   style={{ display: 'none' }}
//                   id="create-featured-image"
//                   type="file"
//                   onChange={handleMainImageUpload}
//                 />
//                 <label htmlFor="create-featured-image">
//                   <Button
//                     variant="outlined"
//                     component="span"
//                     startIcon={<ImageIcon />}
//                   >
//                     Upload Cover Image
//                   </Button>
//                 </label>
//                 {formData.image && (
//                   <Typography variant="body2" sx={{ ml: 2 }}>
//                     Image uploaded
//                   </Typography>
//                 )}
//               </Box>
//             </Grid>
            
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Description"
//                 name="description"
//                 value={formData.description}
//                 onChange={handleInputChange}
//                 variant="outlined"
//                 multiline
//                 rows={3}
//                 required
//               />
//             </Grid>
            
//             {/* PrimeReact Editor in Create Dialog */}
//             <Grid item xs={12}>
//               <Typography variant="subtitle1" sx={{ mb: 1 }}>Content</Typography>
//               <Editor
//                 style={{ height: '300px' }}
//                 value={formData.content}
//                 onTextChange={(e) => handleEditorChange(e.htmlValue)}
//                 headerTemplate={editorHeader}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleCreateBlog} 
//             variant="contained" 
//             color="primary"
//             // disabled={!formData.title || !formData.description || !formData.content || !formData.image}
//           >
//             Create Blog
//           </Button>
//         </DialogActions>
//       </Dialog>
      
//       {/* Add Image Dialog */}
//       <Dialog 
//         open={openImageDialog} 
//         onClose={() => setOpenImageDialog(false)}
//       >
//         <DialogTitle>Add Image to Blog</DialogTitle>
//         <DialogContent>
//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             <Grid item xs={12}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <input
//                   accept="image/*"
//                   style={{ display: 'none' }}
//                   id="additional-image-upload"
//                   type="file"
//                   onChange={handleImageUpload}
//                 />
//                 <label htmlFor="additional-image-upload">
//                   <Button
//                     variant="outlined"
//                     component="span"
//                     startIcon={<ImageIcon />}
//                   >
//                     Select Image
//                   </Button>
//                 </label>
//                 {imageData.file && (
//                   <Typography variant="body2" sx={{ ml: 2 }}>
//                     Image selected
//                   </Typography>
//                 )}
//               </Box>
//             </Grid>
            
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Insert After Paragraph #"
//                 type="number"
//                 value={imageData.position}
//                 onChange={(e) => setImageData({...imageData, position: e.target.value})}
//                 variant="outlined"
//                 InputProps={{ inputProps: { min: 1 } }}
//                 helperText="Specify which paragraph this image should appear after"
//               />
//             </Grid>
            
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Image Caption (Optional)"
//                 value={imageData.caption}
//                 onChange={(e) => setImageData({...imageData, caption: e.target.value})}
//                 variant="outlined"
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenImageDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleAddImage} 
//             variant="contained" 
//             color="primary"
//             // disabled={!imageData.file}
//           >
//             Add Image
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// };

// export default Blogs;


























import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { 
  Container, Chip, Divider, CardActions, Grid, Card, CardMedia, 
  CardContent, Typography, Button, Box, IconButton, Dialog, 
  DialogTitle, DialogContent, DialogActions, TextField, MenuItem,
  Select, FormControl, InputLabel, Fab, Tooltip
} from "@mui/material";
import { 
  AccessTime, ArrowBack, Edit, Delete, Add as AddIcon, 
  Image as ImageIcon, Save, Close 
} from "@mui/icons-material";
import "../styles/home.css";  
import axios from "axios";

// PrimeReact imports
import { Editor } from 'primereact/editor';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const Blogs = ({ role }) => {
  const backendUrl = 'https://python-backend-68898252993.us-central1.run.app';
  const { id } = useParams();
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [featuredBlog, setFeaturedBlog] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  
  // Form states for editing or creating
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    category: "",
    content: "",
    image: "",
    featured: false,
    insertImageAfter: 2,
    additionalImages: []
  });
  
  // New image data
  const [imageData, setImageData] = useState({
    file: null,
    position: 0,
    caption: ""
  });

  // Compute insertPosition and paragraphs only when selectedBlog exists
  const insertPosition = selectedBlog?.insertImageAfter ?? 2;
  const paragraphs = selectedBlog?.content ? selectedBlog.content.split('\n\n') : [];

  useEffect(() => {
    // Fetch blogs from API
    fetchBlogs();
  }, [id]);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get(`${backendUrl}/api/blogs`);
      const blogsData = response.data;
      
      setBlogs(blogsData.posts);
      
      // Set featured blog (first blog or one marked as featured)
      const featured = blogsData.posts.find(blog => blog.featured) || blogsData.posts[0];
      setFeaturedBlog(featured);
      
      // Set selected blog if ID is in URL
      if (id) {
        const blogDetailResponse = await axios.get(`${backendUrl}/api/blogs/${parseInt(id)}`);
        setSelectedBlog(blogDetailResponse.data);
        // Scroll to top when blog detail page loads
        window.scrollTo(0, 0);
      } else {
        setSelectedBlog(null);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  // Function to format date in a more readable way
  const formatDate = (dateString) => {
    if (!dateString) return "";
    if (dateString === "Today" || dateString === "Yesterday" || dateString.includes("days ago")) {
      return dateString;
    }
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  // Handle content change from PrimeReact Editor
  const handleEditorChange = (htmlContent) => {
    setFormData({
      ...formData,
      content: htmlContent
    });
  };

// Handle image upload
// Handle image upload
const handleImageUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const cloudinaryData = new FormData(); // Renamed to avoid conflict
  cloudinaryData.append('file', file);
  cloudinaryData.append("upload_preset", "Brian_Karsh");

  try {
    // Upload directly to Cloudinary
    const response = await fetch("https://api.cloudinary.com/v1_1/dyglrkcfq/image/upload", {
      method: "POST",
      body: cloudinaryData,
    });
    
    const data = await response.json();
    
    if (data.secure_url) {
      setImageData(prevImageData => ({
        ...prevImageData,
        file: data.secure_url
      }));
    }
  } catch (error) {
    console.error("Error uploading image to Cloudinary:", error);
  }
};

// Handle main blog image upload
const handleMainImageUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const cloudinaryData = new FormData(); // Renamed to avoid conflict
  cloudinaryData.append('file', file);
  cloudinaryData.append("upload_preset", "Brian_Karsh");

  try {
    // Upload directly to Cloudinary
    const response = await fetch("https://api.cloudinary.com/v1_1/dyglrkcfq/image/upload", {
      method: "POST",
      body: cloudinaryData,
    });
    
    const data = await response.json();
    
    if (data.secure_url) {
      setFormData(prevFormData => ({
        ...prevFormData,  // Use functional update to reference the previous state
        image: data.secure_url
      }));
    }
  } catch (error) {
    console.error("Error uploading image to Cloudinary:", error);
  }
};

  // Add image to the blog content
  const handleAddImage = () => {
    if (!imageData.file) return;

    const newAdditionalImages = [
      ...formData.additionalImages,
      {
        path: imageData.file,
        position: parseInt(imageData.position),
        caption: imageData.caption
      }
    ];

    setFormData({
      ...formData,
      additionalImages: newAdditionalImages
    });

    // Reset image form
    setImageData({
      file: null,
      position: 0,
      caption: ""
    });

    setOpenImageDialog(false);
  };

  // Remove additional image
  const handleRemoveImage = (index) => {
    const newAdditionalImages = [...formData.additionalImages];
    newAdditionalImages.splice(index, 1);
    
    setFormData({
      ...formData,
      additionalImages: newAdditionalImages
    });
  };

  // Open edit mode with current blog data
  const handleEditBlog = () => {
    if (!selectedBlog) return;

    setFormData({
      title: selectedBlog.title || "",
      description: selectedBlog.description || "",
      category: selectedBlog.category || "",
      content: selectedBlog.content || "",
      image: selectedBlog.image || "",
      featured: selectedBlog.featured || false,
      insertImageAfter: selectedBlog.insertImageAfter || 2,
      additionalImages: selectedBlog.additionalImages || []
    });

    setEditMode(true);
  };

  // Open create blog dialog
  const handleOpenCreateDialog = () => {
    setFormData({
      title: "",
      description: "",
      category: "",
      content: "",
      image: "",
      featured: false,
      insertImageAfter: 2,
      additionalImages: []
    });
    setOpenDialog(true);
  };

  // Create new blog
// Update your handleCreateBlog function
const handleCreateBlog = async () => {
  try {
    // Get the token from local storage or wherever you store it after login
    const token = localStorage.getItem('token'); // or from your auth state
    
    const response = await axios.post( `${backendUrl}/api/blogs/create` , formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.data.success) {
      setOpenDialog(false);
      fetchBlogs();
      navigate(`/blogs/${response.data.id}`);
    }
  } catch (error) {
    console.error("Error creating blog:", error);
  }
};

  // Update existing blog
  const handleUpdateBlog = async () => {
    if (!selectedBlog) return;

    try {
      const token = localStorage.getItem('token'); // or from your auth state


      const response = await axios.put(`${backendUrl}/api/blogs/${selectedBlog.id}/update`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
      if (response.data.success) {
        setEditMode(false);
        fetchBlogs();
      }
    } catch (error) {
      console.error("Error updating blog:", error);
    }
  };

  // Delete blog
  const handleDeleteBlog = async () => {
    if (!selectedBlog) return;
  
    if (window.confirm("Are you sure you want to delete this blog?")) {
      try {
        const token = localStorage.getItem('token'); // Get token from localStorage or your auth state
  
        const response = await axios.delete(`${backendUrl}/api/blogs/${selectedBlog.id}/delete`, {
          headers: {
            'Authorization': `Bearer ${token}`, // Add Authorization header
          },
        });
  
        if (response.data.success) {
          navigate('/blogs');
          fetchBlogs();
        }
      } catch (error) {
        console.error("Error deleting blog:", error);
      }
    }
  };
  

  // Cancel editing
  const handleCancelEdit = () => {
    setEditMode(false);
  };

  // Set up Editor header template
  const editorHeader = (
    <span className="ql-formats">
      <button className="ql-bold" aria-label="Bold"></button>
      <button className="ql-italic" aria-label="Italic"></button>
      <button className="ql-underline" aria-label="Underline"></button>
      <button className="ql-strike" aria-label="Strike"></button>
      <button className="ql-blockquote" aria-label="Blockquote"></button>
      <button className="ql-list" value="ordered" aria-label="Ordered List"></button>
      <button className="ql-list" value="bullet" aria-label="Unordered List"></button>
      <button className="ql-link" aria-label="Insert Link"></button>
      <button className="ql-image" aria-label="Insert Image"></button>
      <button className="ql-code-block" aria-label="Code Block"></button>
      <select className="ql-size">
        <option value="small">Small</option>
        <option selected>Normal</option>
        <option value="large">Large</option>
        <option value="huge">Huge</option>
      </select>
      <select className="ql-header">
        <option value="1">Heading 1</option>
        <option value="2">Heading 2</option>
        <option value="3">Heading 3</option>
        <option value="4">Heading 4</option>
        <option value="5">Heading 5</option>
        <option value="6">Heading 6</option>
        <option selected>Normal</option>
      </select>
    </span>
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 12, mb: 8 }}>
      {!selectedBlog ? (
        // Blog listing page
        <>
          {/* Hero Section with Featured Blog */}
          <Box 
            className="featured-blog" 
            sx={{ 
              position: 'relative', 
              mb: 6, 
              borderRadius: 2, 
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              height: {xs: '400px', md: '500px'}
            }}
          >
            {featuredBlog && (
              <>
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${featuredBlog.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: 'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.2))'
                    }
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    padding: {xs: 3, md: 5},
                    color: 'white',
                    zIndex: 1
                  }}
                >
                  <Chip 
                    label="Featured" 
                    color="primary" 
                    size="small" 
                    sx={{ mb: 2 }} 
                  />
                  <Typography 
                    variant="h3" 
                    component="h1" 
                    sx={{ 
                      fontWeight: 700, 
                      mb: 2,
                      fontSize: {xs: '1.8rem', sm: '2.5rem', md: '3rem'} 
                    }}
                  >
                    {featuredBlog.title}
                  </Typography>
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      mb: 2, 
                      opacity: 0.9,
                      display: {xs: 'none', sm: 'block'}
                    }}
                  >
                    {featuredBlog.description}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <AccessTime sx={{ fontSize: 16, mr: 1, opacity: 0.8 }} />
                    <Typography variant="body2" sx={{ opacity: 0.8 }}>
                      {formatDate(featuredBlog.date)}
                    </Typography>
                  </Box>
                  <Button 
                    variant="contained" 
                    onClick={() => navigate(`/blogs/${featuredBlog.id}`)}
                    sx={{ mt: 2 }}
                  >
                    Read Article
                  </Button>
                </Box>
              </>
            )}
          </Box>

          {/* Section Title with decoration */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 5, mt: 8 }}>
            <Divider sx={{ flexGrow: 1, mr: 2 }} />
            <Typography 
              variant="h4" 
              component="h2" 
              sx={{ 
                fontWeight: 700,
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: '-8px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '40px',
                  height: '4px',
                  backgroundColor: 'primary.main',
                  borderRadius: '2px'
                }
              }}
            >
              Stay Informed: Latest Articles & Updates
            </Typography>
            <Divider sx={{ flexGrow: 1, ml: 2 }} />
          </Box>

          {/* Create Blog Button */}
          <Box sx={{ display: 'flex', mb: 3, ml: 10 }}>
          {role === "owner" && (
            <Tooltip title="Create New Blog">
              <Fab 
                color="primary" 
                aria-label="add"
                onClick={handleOpenCreateDialog}
                sx={{
                  bottom: 32,
                  right: 82,
                  zIndex: 1
                }}
              >

     
            <AddIcon />
          

          


              </Fab>
            </Tooltip>
              )}
          </Box>

          {/* Blog Cards */}
          <Grid container spacing={4} justifyContent="center">
            {blogs.map((blog) => (
              <Grid item key={blog.id} xs={12} sm={6} md={4}>
                <Card 
                  className="blog-card" 
                  sx={{ 
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column', 
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    borderRadius: 2,
                    overflow: 'hidden',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
                    }
                  }}
                >
                  <Box sx={{ position: 'relative' }}>
                    <CardMedia 
                      component="img" 
                      height="200"
                      image={blog.image} 
                      alt={blog.title} 
                      className="blog-image"
                      sx={{ 
                        height: '200px', 
                        objectFit: 'cover'
                      }}  
                    />
                    {blog.category && (
                      <Chip
                        label={blog.category}
                        size="small"
                        sx={{
                          position: 'absolute',
                          top: 12,
                          left: 12,
                          backgroundColor: 'primary.main',
                          color: 'white',
                          fontWeight: 600
                        }}
                      />
                    )}
                  </Box>
                  <CardContent 
                    sx={{ 
                      flexGrow: 1, 
                      p: 3
                    }}
                  >
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        mb: 1,
                        color: 'text.secondary' 
                      }}
                    >
                      <AccessTime sx={{ fontSize: 16, mr: 1 }} />
                      <Typography variant="caption">
                        {formatDate(blog.date)}
                      </Typography>
                    </Box>
                    <Typography 
                      variant="h6" 
                      component="h3" 
                      sx={{ 
                        fontWeight: 600, 
                        lineHeight: 1.3,
                        mb: 1.5,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {blog.title}
                    </Typography>
                    <Typography 
                      variant="body2" 
                      color="text.secondary"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        mb: 2
                      }}
                    >
                      {blog.description}
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ p: 2, pt: 0 }}>
                    <Button 
                      size="small" 
                      color="primary"
                      onClick={() => navigate(`/blogs/${blog.id}`)}
                      sx={{ ml: 'auto' }}
                    >
                      Read More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        // Selected Blog Detail View
        <Box 
          sx={{
            textAlign: 'justify',
            maxWidth: '750px',
            mx: 'auto',
            backgroundColor: '#ffffff',
            pt: { xs: 2, md: 4 }
          }}
        >
          {/* Back Button and Edit/Delete Controls */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
            <Button 
              startIcon={<ArrowBack />}
              onClick={() => navigate("/blogs")} 
              sx={{ 
                color: 'text.secondary',
                fontWeight: 400,
                fontSize: '0.875rem',
                pl: 0,
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: 'primary.main'
                }
              }}
              variant="text"
            >
              Back to Articles
            </Button>
            
            {!editMode && (
              <Box>
                <Tooltip title="Edit Blog">
                  <IconButton 
                    color="primary" 
                    onClick={handleEditBlog}
                    sx={{ mr: 1 }}
                  >

  
                       {role === "owner" && (
                           <Edit />
                            )}
                  

                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete Blog">
                  <IconButton 
                    color="error" 
                    onClick={handleDeleteBlog}
                  >
                  
                    {role === "owner" && (
                          <Delete />
                            )}
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            
            {editMode && (
              <Box>
                <Tooltip title="Save Changes">
                  <IconButton 
                    color="primary" 
                    onClick={handleUpdateBlog}
                    sx={{ mr: 1 }}
                  >
                    <Save />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Cancel">
                  <IconButton 
                    color="error" 
                    onClick={handleCancelEdit}
                  >
                    <Close />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          </Box>
          
          {!editMode ? (
            // Normal Blog View
            <>
              {/* Blog Header */}
              <Box sx={{ mb: 6 }}>
                {/* Category Tag */}
                {selectedBlog.category && (
                  <Chip 
                    label={selectedBlog.category} 
                    size="small" 
                    color="primary"
                    sx={{ 
                      mb: 2.5, 
                      fontWeight: 500,
                      borderRadius: '4px',
                      height: '24px'
                    }}
                  />
                )}
                
                {/* Blog Title */}
                <Typography 
                  variant="h1" 
                  component="h1" 
                  sx={{ 
                    fontWeight: 700, 
                    lineHeight: 1.2,
                    mb: 3,
                    fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                    fontFamily: '"Playfair Display", serif',
                  }}
                >
                  {selectedBlog.title}
                </Typography>
                
                {/* Meta Info */}
                <Box 
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    mb: 3,
                    color: 'text.secondary'
                  }}
                >
                  <Typography 
                    variant="body2"
                    sx={{
                      fontFamily: '"Inter", sans-serif',
                      fontSize: '0.875rem'
                    }}
                  >
                    {formatDate(selectedBlog.date)}
                  </Typography>
                  <Box 
                    component="span" 
                    sx={{ 
                      mx: 1.5, 
                      width: '4px', 
                      height: '4px', 
                      borderRadius: '50%', 
                      backgroundColor: 'text.secondary', 
                      display: 'inline-block' 
                    }} 
                  />
                  <Typography 
                    variant="body2"
                    sx={{
                      fontFamily: '"Inter", sans-serif',
                      fontSize: '0.875rem'
                    }}
                  >
                    {selectedBlog.readTime || '5 min read'}
                  </Typography>
                </Box>
              </Box>

              {/* Featured Image */}
              <Box 
                sx={{ 
                  width: '100%', 
                  overflow: 'hidden',
                  mb: 6,
                }}
              >
                <img 
                  src={selectedBlog.image} 
                  alt={selectedBlog.title} 
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    maxHeight: '500px',
                    display: 'block'
                  }} 
                />
              </Box>
              
              {/* Content */}
              <Box 
                sx={{
                  mb: 8,
                  px: { xs: 2, sm: 0 },
                  '& p:first-of-type::first-letter': {
                    fontSize: '3.75rem',
                    lineHeight: 0.8,
                    fontWeight: 700,
                    float: 'left',
                    mr: 1.5,
                    mt: 0.5,
                    fontFamily: '"Playfair Display", serif',
                  },
                  '& .blog-content': {
                    mb: 4,
                    lineHeight: 1.9,
                    fontSize: '1.25rem',
                    color: '#2F2E2E',
                    fontFamily: '"Inter", sans-serif',
                    letterSpacing: '0.015em'
                  }
                }}
              >
                {/* If the content is HTML (from rich text editor) */}
                {selectedBlog.content.includes('<') && selectedBlog.content.includes('>') ? (
                  <div 
                    className="blog-content"
                    dangerouslySetInnerHTML={{ __html: selectedBlog.content }}
                  />
                ) : (
                  // If the content is plain text (legacy)
                  paragraphs.map((para, index) => (
                    <React.Fragment key={index}>
                      <Typography
                        variant="body1"
                        component="p"
                        sx={{
                          mb: 4,
                          lineHeight: 1.9,
                          fontSize: '1.25rem',
                          color: '#2F2E2E',
                          fontFamily: '"Inter", sans-serif',
                          letterSpacing: '0.015em',
                          fontWeight: index === 0 ? 500 : 400
                        }}
                      >
                        {para}
                      </Typography>
                      
                      {/* Display additional images at their specified positions */}
                      {selectedBlog.additionalImages?.some(img => img.position === index + 1) && 
                        selectedBlog.additionalImages
                          .filter(img => img.position === index + 1)
                          .map((img, imgIndex) => (
                            <Box key={imgIndex} sx={{ my: 5 }}>
                              <img
                                src={img.path} 
                                alt={img.caption || `Image ${imgIndex}`}
                                style={{
                                  width: '100%',
                                  height: 'auto',
                                  objectFit: 'cover'
                                }}
                              />
                              {img.caption && (
                                <Typography 
                                  variant="caption" 
                                  sx={{ 
                                    display: 'block', 
                                    textAlign: 'center', 
                                    mt: 1, 
                                    color: 'text.secondary',
                                    fontStyle: 'italic',
                                    fontFamily: '"Inter", sans-serif',
                                  }}
                                >
                                  {img.caption}
                                </Typography>
                              )}
                            </Box>
                          ))
                      }
                    </React.Fragment>
                  ))
                )}
                
                {/* Display additional images after content */}
                {selectedBlog.additionalImages?.filter(img => !paragraphs[img.position - 1]).map((img, imgIndex) => (
                  <Box key={imgIndex} sx={{ my: 5 }}>
                    <img
                      src={img.path} 
                      alt={img.caption || `Image ${imgIndex}`}
                      style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'cover'
                      }}
                    />
                    {img.caption && (
                      <Typography 
                        variant="caption" 
                        sx={{ 
                          display: 'block', 
                          textAlign: 'center', 
                          mt: 1, 
                          color: 'text.secondary',
                          fontStyle: 'italic',
                          fontFamily: '"Inter", sans-serif',
                        }}
                      >
                        {img.caption}
                      </Typography>
                    )}
                  </Box>
                ))}
              </Box>

              {/* Related Articles - Wix style */}
              <Box sx={{ mt: 10, mb: 4 }}>
                <Typography 
                  variant="h2" 
                  component="h2" 
                  sx={{ 
                    fontWeight: 700, 
                    mb: 5,
                    fontSize: '1.75rem',
                    fontFamily: '"Playfair Display", serif',
                    position: 'relative',
                    display: 'inline-block',
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      bottom: '-10px',
                      left: 0,
                      width: '40px',
                      height: '3px',
                      backgroundColor: 'primary.main'
                    }
                  }}
                >
                  You might also like
                </Typography>
                <Grid container spacing={4} sx={{ mt: 2 }}>
                  {blogs
                    .filter(blog => blog.id !== selectedBlog.id)
                    .slice(0, 3)
                    .map((blog) => (
                      <Grid item key={blog.id} xs={12} sm={6} md={4}>
                        <Card 
                          onClick={() => navigate(`/blogs/${blog.id}`)}
                          sx={{ 
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            border: 'none',
                            boxShadow: 'none',
                            borderRadius: 0,
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: 'transparent',
                            '&:hover': {
                              '& .blog-image': {
                                transform: 'scale(1.05)'
                              },
                              '& .blog-title': {
                                color: 'primary.main'
                              }
                            }
                          }}
                        >
                          <Box sx={{ overflow: 'hidden', mb: 2 }}>
                            <CardMedia 
                              component="img" 
                              image={blog.image} 
                              alt={blog.title}
                              className="blog-image"
                              sx={{ 
                                transition: 'transform 0.6s ease',
                                objectFit: 'cover',
                                height: '200px',
                                width: '100%',
                              }}
                            />
                          </Box>
                          <CardContent sx={{ p: 0, flexGrow: 1 }}>
                            <Typography 
                              variant="body2" 
                              color="text.secondary"
                              sx={{ 
                                mb: 1,
                                fontFamily: '"Inter", sans-serif',
                                fontSize: '0.875rem',
                                textTransform: 'uppercase',
                              }}
                            >
                              {formatDate(blog.date)}
                            </Typography>
                            <Typography 
                              variant="subtitle1"
                              component="h4"
                              className="blog-title"
                              sx={{ 
                                fontWeight: 600,
                                fontFamily: '"Inter", sans-serif',
                                fontSize: '1.125rem',
                                transition: 'color 0.2s ease',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                letterSpacing: 'normal',
                                lineHeight: '1.2',
                                whiteSpace: 'normal',
                              }}
                            >
                              {blog.title}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                </Grid>
              </Box>
            </>
          ) : (
            // Edit Mode View with PrimeReact Editor
            <Box sx={{ mb: 8 }}>
              {/* Edit Form */}
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Blog Title"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    variant="outlined"
                    required
                    margin="normal"
                  />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Category"
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                    variant="outlined"
                    margin="normal"
                  />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                    <input
                      accept="image/*"
                      style={{ display: 'none' }}
                      id="featured-image-upload"
                      type="file"
                      onChange={handleMainImageUpload}
                    />
                    <label htmlFor="featured-image-upload">
                      <Button
                        variant="outlined"
                        component="span"
                        startIcon={<ImageIcon />}
                      >
                        Upload Cover Image
                      </Button>
                    </label>
                    {formData.image && (
                      <Typography variant="body2" sx={{ ml: 2 }}>
                        Image uploaded
                      </Typography>
                    )}
                  </Box>
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    variant="outlined"
                    multiline
                    rows={3}
                    margin="normal"
                    required
                  />
                </Grid>
                
                {/* PrimeReact Editor */}
                <Grid item xs={12}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>Content</Typography>
                  <Editor
                    style={{ height: '400px' }}
                    value={formData.content}
                    onTextChange={(e) => handleEditorChange(e.htmlValue)}
                    headerTemplate={editorHeader}
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                    <Typography variant="h6" component="h3">
                      Additional Images
                    </Typography>
                    <Button 
                      variant="contained" 
                      color="primary"
                      startIcon={<AddIcon />}
                      onClick={() => setOpenImageDialog(true)}
                    >
                      Add Image
                    </Button>
                  </Box>
                  
                  {/* List of additional images */}
                  {formData.additionalImages.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Inserted Images:
                      </Typography>
                      <Grid container spacing={2}>
                        {formData.additionalImages.map((img, index) => (
                          <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card sx={{ position: 'relative' }}>
                              <CardMedia
                                component="img"
                                height="140"
                                image={img.path}
                                alt={img.caption || `Image ${index + 1}`}
                              />
                              <CardContent>
                                <Typography variant="body2">
                                  Position: After paragraph {img.position}
                                </Typography>
                                {img.caption && (
                                  <Typography variant="body2" color="text.secondary">
                                    Caption: {img.caption}
                                  </Typography>
                                )}
                              </CardContent>
                              <CardActions>
                                <IconButton 
                                  size="small" 
                                  color="error"
                                  onClick={() => handleRemoveImage(index)}
                                >
                                  <Delete />
                                </IconButton>
                              </CardActions>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
          )}
        </Box>
      )}
      
      {/* Create Blog Dialog */}
      <Dialog 
        open={openDialog} 
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Create New Blog</DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Blog Title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                variant="outlined"
                required
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Category"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                variant="outlined"
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <input
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="create-featured-image"
                  type="file"
                  onChange={handleMainImageUpload}
                />
                <label htmlFor="create-featured-image">
                  <Button
                    variant="outlined"
                    component="span"
                    startIcon={<ImageIcon />}
                  >
                    Upload Cover Image
                  </Button>
                </label>
                {formData.image && (
                  <Typography variant="body2" sx={{ ml: 2 }}>
                    Image uploaded
                  </Typography>
                )}
              </Box>
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                variant="outlined"
                multiline
                rows={3}
                required
              />
            </Grid>
            
            {/* PrimeReact Editor in Create Dialog */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Content</Typography>
              <Editor
                style={{ height: '300px' }}
                value={formData.content}
                onTextChange={(e) => handleEditorChange(e.htmlValue)}
                headerTemplate={editorHeader}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button 
            onClick={handleCreateBlog} 
            variant="contained" 
            color="primary"
            // disabled={!formData.title || !formData.description || !formData.content || !formData.image}
          >
            Create Blog
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Add Image Dialog */}
      <Dialog 
        open={openImageDialog} 
        onClose={() => setOpenImageDialog(false)}
      >
        <DialogTitle>Add Image to Blog</DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <input
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="additional-image-upload"
                  type="file"
                  onChange={handleImageUpload}
                />
                <label htmlFor="additional-image-upload">
                  <Button
                    variant="outlined"
                    component="span"
                    startIcon={<ImageIcon />}
                  >
                    Select Image
                  </Button>
                </label>
                {imageData.file && (
                  <Typography variant="body2" sx={{ ml: 2 }}>
                    Image selected
                  </Typography>
                )}
              </Box>
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Insert After Paragraph #"
                type="number"
                value={imageData.position}
                onChange={(e) => setImageData({...imageData, position: e.target.value})}
                variant="outlined"
                InputProps={{ inputProps: { min: 1 } }}
                helperText="Specify which paragraph this image should appear after"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Image Caption (Optional)"
                value={imageData.caption}
                onChange={(e) => setImageData({...imageData, caption: e.target.value})}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenImageDialog(false)}>Cancel</Button>
          <Button 
            onClick={handleAddImage} 
            variant="contained" 
            color="primary"
            // disabled={!imageData.file}
          >
            Add Image
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Blogs;